import { SubformProps } from "../pages/consumerApplicationForm"

export const AddOrDeclineCoborrower = ({ formData, update, save }: Partial<SubformProps>) => {
  return <div className="buttons">
    <button
      type="button"
      className="btn btn-primary"
      onClick={() => update('includeCoBorrower', 'yes')}>Add Coborrower</button>
    <button
      type="button"
      className="btn btn-secondary"
      onClick={() => {
        save({
          data: {
            ...formData,
            declinedToAddCoborrowerDate: new Date(),
            includeCoBorrower: 'no'
          },
          advance: false
        })
      }}>I do not wish to add a coborrower</button>
  </div>
}

